import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, toDisplayString as _toDisplayString, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0a1f8bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = ["onClick", "to"]
const _hoisted_3 = ["title"]
const _hoisted_4 = {
  key: 2,
  "data-testid": "sidebar-counter-central-de-vagas",
  class: "ml-auto flex-none rounded-full bg-[#FEF3E7] px-2 text-xs font-semibold text-[#B45309]"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["onClick", "to"]
const _hoisted_10 = { class: "mx-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_left_arrow = _resolveComponent("left-arrow")!
  const _component_rigth_arrow = _resolveComponent("rigth-arrow")!
  const _component_LabelBadge = _resolveComponent("LabelBadge")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_up_icon = _resolveComponent("up-icon")!
  const _component_down_icon = _resolveComponent("down-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isMobile && $setup.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black opacity-50 z-10",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.showSideBar && $setup.showSideBar(...args)))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([[
        $setup.isMobile && $setup.isOpen ? 'fixed z-20' : '',
        $setup.isOpen ? 'w-72' : 'w-16',
        $setup.isMobile && !$setup.isOpen ? 'hidden' : ''
      ], "inset-y-0 left-0 flex flex-col transition-all duration-300 transform bg-white border-r border-gray-200 min-h-[100vh]"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex items-center px-4 flex-shrink-0", $setup.isOpen ? 'h-20' : 'h-20 justify-center'])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["w-full flex items-center", $setup.isOpen ? 'justify-between' : 'justify-center'])
        }, [
          ($setup.isOpen)
            ? (_openBlock(), _createBlock(_component_Logo, {
                key: 0,
                width: "120px",
                logo: "variant"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.showSideBar && $setup.showSideBar(...args))),
            class: "text-gray-500 focus:outline-none lg:block"
          }, [
            ($setup.isOpen)
              ? (_openBlock(), _createBlock(_component_left_arrow, { key: 0 }))
              : (_openBlock(), _createBlock(_component_rigth_arrow, { key: 1 }))
          ])
        ], 2)
      ], 2),
      _createElementVNode("nav", {
        class: _normalizeClass(["mt-6 flex-1 overflow-y-auto", $setup.isOpen ? 'px-4' : 'px-2'])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredMenus, (menu, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            onClick: ($event: any) => ($setup.clickItem($event, menu)),
            class: "flex flex-col",
            to: menu.path
          }, [
            (menu.active && $setup.isAuthorized(menu))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([[
              $setup.isMenuActive(menu) ? $setup.activeClass : $setup.inactiveClass,
              $setup.isOpen ? 'px-6' : 'justify-center'
            ], "flex items-center py-4 mt-1 duration-200 rounded cursor-pointer hover-scale"])
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent($setup.getIconComponent(menu.icon)), {
                    color: $setup.isMenuActive(menu) ? '#FFFFFF' : '#1E1E29'
                  }, null, 8, ["color"])),
                  ($setup.isOpen)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(
                menu.badge || $setup.menuCounter(menu) !== null
                  ? 'ml-4 mr-2 min-w-0 truncate whitespace-nowrap'
                  : 'mx-4 whitespace-nowrap'
              ),
                        title: menu.badge || $setup.menuCounter(menu) !== null ? menu.name : undefined,
                        "data-testid": "sidebar-menu-name"
                      }, _toDisplayString(menu.name), 11, _hoisted_3))
                    : _createCommentVNode("", true),
                  ($setup.isOpen && menu.badge)
                    ? (_openBlock(), _createBlock(_component_LabelBadge, {
                        key: 1,
                        label: menu.badge,
                        icon: null,
                        color: "blue",
                        size: "small",
                        class: "flex-none",
                        "data-testid": "sidebar-badge-central-de-vagas"
                      }, null, 8, ["label"]))
                    : _createCommentVNode("", true),
                  ($setup.isOpen && $setup.menuCounter(menu) !== null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($setup.menuCounter(menu)), 1))
                    : _createCommentVNode("", true),
                  (!$setup.isOpen)
                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                        key: 3,
                        activator: "parent",
                        location: "right",
                        text: menu.name
                      }, null, 8, ["text"]))
                    : _createCommentVNode("", true),
                  (menu.childrens.length > 0 && $setup.isOpen)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 4,
                        class: "ml-auto",
                        onClick: ($event: any) => ($setup.clickExpand($event, menu.path))
                      }, [
                        ($setup.expandChildrens[menu.path])
                          ? (_openBlock(), _createElementBlock("a", _hoisted_6, [
                              _createVNode(_component_up_icon, {
                                color: $setup.isMenuActive(menu) ? '#FFFFFF' : '#1E1E29'
                              }, null, 8, ["color"])
                            ]))
                          : (_openBlock(), _createElementBlock("a", _hoisted_7, [
                              _createVNode(_component_down_icon, {
                                color: $setup.isMenuActive(menu) ? '#FFFFFF' : '#1E1E29'
                              }, null, 8, ["color"])
                            ]))
                      ], 8, _hoisted_5))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true),
            (menu.childrens.length > 0 && $setup.expandChildrens[menu.path] && $setup.isOpen)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.childrens, (children, childIndex) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: childIndex }, [
                      ($setup.isAuthorized(children))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass([[$setup.route.path === children.path ? $setup.activeClass : $setup.inactiveClass], "flex items-center px-6 py-2.5 duration-200 rounded cursor-pointer hover-scale"]),
                            onClick: ($event: any) => ($setup.clickChildrenItem($event, children)),
                            to: children.path
                          }, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(children.name), 1)
                          ], 10, _hoisted_9))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_2))
        }), 128))
      ], 2)
    ], 2)
  ]))
}